import { Button, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useEffect, useState } from 'react';

const FocusBusToggleComponent = ({ vehiclesPosition, setBusOnFocusID, setCenterToBusLive, centerToBusLive }) => {
  const [option, setOption] = useState('');

  const handleOption = (event, newOption) => {
    // use this to be unable to deselect a bus when clicking again in the same toggle button
    if (newOption !== null) {
      setOption(newOption);
    }
  };

  useEffect(() => {
    !centerToBusLive && setOption(null); 
  }, [centerToBusLive]);

  return (
    <ToggleButtonGroup value={option} exclusive onChange={handleOption} aria-label='text option'>
      {vehiclesPosition.map((item, index) => (
        <ToggleButton
          color='secondary'
          size='medium'
          key={index}
          value={item.vehicleCode}
          aria-label={item.vehicleCode}
          disableFocusRipple={true}
          sx={{padding: '0.4rem 1rem'}}
          // disableRipple={true}
          onClick={() => {
            setBusOnFocusID(item.vehicleCode);
            setCenterToBusLive(true);
          }}
        >
          {item.vehicleCode.slice(-5).replace('_', ':')}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default FocusBusToggleComponent;
